<template>
  <div class="sensitive">
    <content-top
      :title="modalTit"
      :untext="unTTxt"
      :fields="fields"
      :type="type"
      :sensitive-fields="sensitiveFields"
      @edit="toEdit"
      @setSentiveHide="setSentiveHide"
    />
    <a-modal
      :title="modalTit2"
      :visible="visibleEditModal"
      :mask-closable="false"
      :ok-text="okTTxt"
      :cancel-text="cancelTxt"
      :confirm-loading="confirmLoading"
      wrap-class-name="modal_container"
      @ok="handleConfirmSubmit"
      @cancel="handleCancel"
    >
      <div class="modal_content">
        <modal-search
          v-if="!isView"
          :data-source="dataSource"
          @select="onSelect"
          @search="onSearch"
        />
        <div
          ref="check_main"
          class="modal_main"
        >
          <a-form
            ref="sentive"
            :form="form"
          >
            <a-form-item v-if="!isView">
              <a-checkbox-group
                v-decorator="['data', {initialValue: setedFields}]"
                class="fields_group scroll_bar_beautify_ff"
                :options="allSensitiveData"
              />
            </a-form-item>
            <a-form-item v-else>
              <a-checkbox-group
                v-decorator="['range', {initialValue: setedViewFields}]"
                :options="allViewData"
              />
            </a-form-item>
          </a-form>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script type="text/ecmascript-6">
import ContentTop from '@/components/pc/config/sensitive/ContentTop'
import ModalSearch from '@/components/pc/config/sensitive/ModalSearch'
import { mapState, mapActions } from 'vuex'
export default {
  components: { ContentTop, ModalSearch },
  props: {
    fields: {
      type: Array,
      default: () => ({})
    },
    type: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      visibleEditModal: false,
      form: this.$form.createForm(this),
      dataSource: [],
      confirmLoading: false
    }
  },
  computed: {
    ...mapState('config/sensitive', ['allSensitiveFields', 'viewSensitive', 'sensitiveFields']),
    allSensitiveData () {
      return this.allSensitiveFields.map(item => {
        return { 'value': item.fieldname, 'label': item.fieldname, 'id': item.id, disabled: item.fieldkey === 'follow_userid' }
      })
    },
    setedFields () {
      return this.allSensitiveFields.filter(item => item.fieldauth === 1).map(item => item.fieldname)
    },
    allViewData () {
      return this.viewSensitive.map(item => {
        return { 'value': item.fieldname, 'label': item.fieldname, 'id': item.fieldkey, disabled: item.fieldkey === 'follow_userid' }
      })
    },
    setedViewFields () {
      return this.viewSensitive.filter(item => item.fieldvalue === 1).map(item => item.fieldname)
    },
    modalTit () {
      return !this.isView ? this.$t('message["646"]') : this.$t('message["1891"]')
    },
    cancelTxt () {
      return this.$t('message["896"]')
    },
    okTTxt () {
      return this.$t('message["915"]')
    },
    modalTit2 () {
      return !this.isView ? this.$t('message["1037"]') : this.$t('message["1891"]')
    },
    unTTxt () {
      return this.$t('message["1550"]')
    },
    isView () {
      return this.type === 'view'
    }
  },
  watch: {
    visibleEditModal (newValue) {
      if (newValue) {
        this.fetchAllSensitiveData()
      }
    }
  },
  methods: {
    ...mapActions('config/sensitive', ['fetchAllSensitiveData', 'searchFields', 'setSensitiveFields']),
    toEdit () {
      this.visibleEditModal = true
    },
    handleConfirmSubmit (e) {
      e && e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          let data = []
          let originalValues = [].concat(...this.isView ? this.viewSensitive : this.allSensitiveFields)
          const type = this.isView ? 'range' : 'data'
          for (let i = 0; i < values[type].length; i++) {
            let item = values[type][i]
            for (let k = 0; k < originalValues.length; k++) {
              if (item === originalValues[k].fieldname) {
                const idkey = this.isView ? originalValues[k].fieldkey : originalValues[k].id
                data.push(idkey)
                originalValues.splice(k, 1)
                break
              }
            }
          }
          this.setSensitive(data)
        }
      })
    },
    handleCancel () {
      this.visibleEditModal = false
    },
    // 设置敏感字段
    async setSensitive (data) {
      this.confirmLoading = true
      const chain = await this.setSensitiveFields()
      data = this.isView ? { range: data } : { data }
      chain.params(data)
        .onSuccess(res => {
          this.handleCancel()
          this.confirmLoading = false
          this.$emit('submit')
        })
        .onNetSuccess((res) => {
          this.confirmLoading = false
        })
        .fetch()
    },
    // 搜索敏感字段
    async onSearch (value) {
      const chain = await this.searchFields()
      chain.params({ 'key': value, edit: 1 })
        .onSuccess(res => {
          this.dataSource = res.list.map(item => item.fieldname).length > 0 ? res.list.map(item => item.fieldname) : [this.$t('message["1553"]')]
        })
        .fetch()
    },
    onSelect (e) {
      let key = 0
      for (let i = 0; i < this.allSensitiveFields.length; i++) {
        if (this.allSensitiveFields[i].fieldname === e) {
          key = i
          break
        }
      }
      this.$nextTick(() => {
        let container = this.$refs.check_main
        let toTopDistence = container.children[0] && container.children[0][key].scrollHeight * key + (key * 5)
        document.querySelector('.fields_group').scrollTop = toTopDistence
      })
    },
    async setSentiveHide (val) {
      const value = val ? 1 : 0
      this.$set(this.sensitiveFields, 'is_hidden_sensitive_field', value)
      this.setedFields.is_hidden_sensitive_field = value
      // this.$refs.sentive.submit()
      // this.handleConfirmSubmit()
      const chain = await this.setSensitiveFields()

      chain.params({ is_hidden_sensitive_field: value })
        .onSuccess(res => {
          this.$emit('submit')
        })
        .onNetSuccess((res) => {
        })
        .fetch()
    }
  }
}
</script>
<style lang="scss" scoped>
.modal_content {
  width: 400px;
  margin: 20px auto 0 auto;
}
.modal_main {
  margin: 20px 0;
}
</style>

<style lang="scss">
.sensitive {
  .ant-modal-content {
    max-height: 550px !important;
  }
}
.fields_group {
  height: 270px;
  overflow-y: auto;
  .ant-checkbox-group-item {
    width: 100% !important;
    height: 32px !important;
    margin: 0 !important;
    line-height: 32px;
  }
  .ant-checkbox-group-item:hover {
    background: #f4f7f9 !important;
  }
}
.modal_container {
  .ant-modal-body {
    padding: 24px 40px;
    .modal_content {
      width: auto;
    }
  }
}
</style>
